import * as Tone from 'tone';

// Tempo-synced ping-pong delay send bus. delayTime is a Tone notation string
// so it follows BPM changes automatically.

export default {
    id: 'fx-delay',
    name: 'Delay',
    register(ctx) {
        const delay = new Tone.PingPongDelay({
            delayTime: '8n',
            feedback: 0.45,
            wet: 1,
        });
        const ch = ctx.mixer.addFxChannel({
            id: 'fx-delay',
            name: 'Delay',
            color: '#bb9af7',
            effectNode: delay,
        });
        ch.setVolume(-6);
    },
};
